<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{this.content[1].tl_code == '-' ? this.$t('components.service.modal.History.33') : this.content[1].typelocal}} #{{this.content[1].transact}}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <!--<div class='d-flex justify-content-between neue'>
        <h2 id="c-m-hp-1">{{this.content[1].tl_code == '-' ? this.$t('components.service.modal.History.33') : this.content[1].typelocal}}, {{ $t('components.service.modal.History.1') }} {{this.content[1].transact}}</h2>
        <i id="c-m-hp-2" class='big item-i x_red' v-on:click='this.close'></i>
    </div>-->
    <div class="text-black bg-white rounded12" :class="{ 'pb48': this.isMobile, 'p24': !this.isMobile }">
        <CustomSelectButton
            v-if="this.merchant_callbacks_tries.length"
            v-model="this.section"
            :options="this.sections"
            class="w-100"
            :class="{ 'mb32': this.isMobile, 'mb40': !this.isMobile }"
        />
        <div v-if="this.section == '0'">
            <h4 class='p-0 mb16 fsp20 lh28 neue'>{{ $t('components.service.modal.History.2') }}</h4>
            <div class="d-flex flex-column gap-3">
                <div 
                    v-for="(row, index) in this.main_content" 
                    class='d-flex align-items-start justify-content-between'
                    :class="{ 'flex-column gap-2': row.id === 'comment', 'gap-3': row.id !== 'comment' }"
                    :key="index"
                >
                    <div class='p-0 primary-grey neue-roman col-4' :id="'c-m-hp-i-1-'+index" :class="{ 'fsp14 lh20': isMobile, 'fsp16': !isMobile }">{{row.param}}</div>
                    <div 
                        v-if="row.id === 'status'"
                        :id="'c-m-hp-i-2-'+index" 
                        class="status"
                        :class="{ 
                            'status-green': this.content[1].done == '1', 
                            'status-red': this.content[1].done == '-2' || this.content[1].done == '2' || this.content[1].done == '5' || this.content[1].done == '-3' || this.content[1].done == '3' || this.content[1].done == '-1',
                            'status-orange': this.content[1].done == '0' || this.content[1].done == '4', 
                            'fsp14 lh20': isMobile,
                            'fsp16 lh24': !isMobile
                        }"
                    >
                        {{ getStatus(row.value) }}
                    </div>
                    <div v-else-if="row.id === 'comment' && !row.value" :class="{ 'fsp14 lh20': isMobile, 'fsp16': !isMobile }">-</div>
                    <Text
                        v-else
                        :id="'c-m-hp-i-2-'+index" 
                        :text="row.value" 
                        :class="{ 'fsp14': isMobile, 'fsp16 lh24': !isMobile, 'justify-content-end col-7': textIsSum(row.id), 'text-start neue-roman': row.id === 'comment', 'text-end': row.id !== 'comment' }"
                        :isSum="textIsSum(row.id)"
                    />
                </div>
            </div>

            <div v-if="this.content[1]['done'] === '1'">
                <h4 class='fsp20 mb-0 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.3') }} </h4>
                <div 
                    v-for="(row, index) in this.acc_balnace" 
                    :key="index" 
                    class='p-0 d-flex container-fluid justify-content-between mt16' 
                    :class="{ 'align-items-start flex-column': this.isMobile, 'gap-3': !this.isMobile }"
                >
                    <div class='d-flex align-items-center gap-1 primary-grey neue-roman text-nowrap' :id="'c-m-hp-i-4-'+index" :class="{ 'fsp14 lh20 mb8': this.isMobile, 'fsp16 lh24': !this.isMobile }">
                        {{ this.getAlias(row.keyt) }}
                        <Icon :name="Number(row.balance_before) < Number(row.balance_after) ? 'arrow-up-2' : 'arrow-down-2'" :active="false" class="c20"/>
                        <!-- {{ row.curr_name }} -->
                    </div>
                    <div class="d-flex align-items-center w-100 text-truncate lh16" :class="{ 'justify-content-end': !this.isMobile }">
                        <div class="neue text-truncate" :id="'c-m-hp-i-5-'+index">
                            <span>
                                <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.balance_before.split('.')[0] }}</span>
                                <span class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.balance_before.split('.')[1] }}</span>
                            </span>
                        </div>  
                        <span class="d-inline-block mx4">→</span>
                        <div class="neue text-truncate" :id="'c-m-hp-i-5-'+index" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">
                            <span>
                                <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.balance_after.split('.')[0] }}</span>
                                <span class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.balance_after.split('.')[1] }}</span>
                            </span>
                        </div>
                        <div class="neue primary-grey text-truncate lh16 ml4" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }"> {{ row.curr_name }}</div>
                    </div>
                </div>
            </div>

            <h4 v-if="this.more_opt.length" class='mb16 fsp20 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.6') }}</h4>
            <div class="d-flex flex-column gap-3">  
                <div class='d-flex p-0 gap-3 container-fluid align-items-start justify-content-between'
                v-for="(row, index) in this.more_opt" :key="index">
                    <div class='col-4 primary-grey neue-roman' :id="'c-m-hp-i-6-'+index" :class="{ 'fsp14 lh20': isMobile, 'fsp16 lh24': !isMobile }">{{row.param}}</div>
                    <Text v-if="row.human_value" :text="row.human_value" class='text-truncate' :id="'c-m-hp-i-7-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }"/>
                    <Text v-else :text="row.value" class='text-truncate' :id="'c-m-hp-i-8-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }" />
                </div>
            </div>
            <div v-if="this.exp_post.length">
                <h4 class='fsp20 mb-0 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.7') }}</h4>
                    <div class='d-flex mt16 p-0 container-fluid justify-content-between'
                    v-for="(row, index) in this.exp_post" :key="index">
                        <div class='col-4 p-0 primary-grey neue-roman' :id="'c-m-hp-i-9-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }">{{row.purpose}}</div>
                        <div class="p-0 col-7">
                            <div class="table-responsive p-0 m-0">
                                <table class="table w-unset table-borderless neue-roman m-0 w-100">
                                    <tbody class=''>
                                        <tr class="d-flex justify-content-end gap-2">
                                            <td class="align-middle p-0 neue-roman text-nowrap" scope="col" :id="'c-m-hp-i-10-'+index">
                                                <div class="d-flex align-items-center">
                                                    <span>
                                                        <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.amount.split('.')[0] }}</span>
                                                        <span v-if="row.amount.split('.')[1]" class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.amount.split('.')[1] }}</span>
                                                    </span>&nbsp;
                                                    <div class="primary-grey neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{row.curr}}</div>
                                                </div>
                                            </td>
                                            <td class="align-middle p-0 neue" :class="{ 'fsp16': !isMobile, 'fsp14': isMobile }" scope="col" :id="'c-m-hp-i-11-'+index">
                                                {{this.substrHash(row.hash)}}
                                            </td>
                                            <td class="align-middle p-0 d-flex align-items-center justify-content-start" scope="col">
                                                <Icon name="copy" class="c18 pointer" @click="copy(row.hash)"/>
                                                <!-- <i v-if='row.hash' :id="'c-m-hp-i-12-'+index" class='item-i copy c18 cli_h pointer' @click="copy(row.hash)"></i> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Text v-if='row.explorer_link' :id="'c-m-hp-i-13-'+index" :text="row.explorer_link" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }" />
                            </div>
                        </div>
                    </div>
            </div>
            <div v-if='this.content[1].need_pay_inflow_finish == 1' class='container-fluid mt24 p-0'>
                <Warning class="m-0" :warning="{ warningType: 'warning', warningText: $t('components.service.modal.History.37') }" :hideCloseBtn="true" />
            </div>

            <div v-if='this.content[1]["temp_block"] != "0" && (this.content[1]["done"] == "0" || this.content[1]["done"] == "4")'>
                <h4 class='mt40 fsp20 lh28 neue mb16' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.12') }}</h4>
                <div class='d-flex p-0 container-fluid align-items-start justify-content-between mb16 gap-3'>
                    <div class='p-0 primary-grey neue-roman'>{{ $t('components.service.modal.History.13') }}</div>
                    <div class='p-0 text-end' id="c-m-hp-8">{{ $t('components.service.modal.History.14') }} {{this.content[1]['date_out_max']}}</div>
                </div>
                <div class='d-flex p-0 container-fluid justify-content-between' :class="{ 'flex-column align-items-start': isMobile, 'align-items-center': !isMobile }">
                    <div class='p-0 primary-grey neue-roman' :class="{ 'mb8': isMobile }">{{ $t('components.service.modal.History.15') }}</div>
                    <div class='d-flex p-0 align-items-center justify-content-end' :class="{ 'col-12': isMobile, 'col-7': !isMobile }">
                        <div class='no-pr flex-grow-1'>
                            <InputSimple
                                id="protect_code"
                                :placeholder="this.$t('components.service.modal.History.54')"
                                @updateParentState="this.updateState" 
                            >
                                <Button id="c-m-hp-9" type='btn-warning' class="h30" @click="this.payProtect">
                                    <span class="fsp14 neue text-nowrap">{{ $t('components.service.modal.History.16') }}</span>
                                </Button>
                            </InputSimple>
                        </div>
                    </div> 
                </div>
            </div>
            <div
                :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }"
                v-if="this.content[1]['code_cmd'] == 'pay_momental' || 
                    this.content[1]['code_cmd'] == 'pay_from_gate' || 
                    this.content[1]['code_cmd'] == 'transfer_keyt' ||
                    (this.content[1]['code_cmd'] == 'pay_id' && this.content[1].tl_code !== '2')"
                @click='() => { save_t = !this.save_t }'
            >
                <span class="link-border color-menu pointer">{{ $t('components.service.modal.History.22') }}</span>
            </div>
            <div v-if='this.save_t' class="mt16">
                <div class='d-flex p-0 container-fluid align-items-center justify-content-between'>
                    <div class="w-100">
                        <InputSimple
                            id="template_name"
                            :placeholder="this.$t('components.service.modal.History.52')"
                            @updateParentState="this.updateState" 
                        >
                            <Button id="c-m-hp-10" type='btn-warning' class="h30" @click="this.saveTemplate">
                                <span class="fsp14 neue text-nowrap">{{ $t('components.service.modal.History.22') }}</span>
                            </Button>
                        </InputSimple>
                    </div>
                </div>
            </div>
            <div 
                v-if="this.isRepeatOperation || +this.content[1].repealing == 1" class='d-flex mx-auto justify-content-end flex-wrap mt40'
                :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }"
            >
                <Button
                    v-if="(!this.isRepeatOperation || +this.content[1].repealing != 1) && (this.isRepeatOperation || +this.content[1].repealing == 1) && this.content[1].need_pay_inflow_finish != 1"
                    :name="$t('components.service.modal.History.51')"
                    class="equal-width h56 mr16"
                    type='btn-outline-grey'
                    @click='this.close'
                />
                <Button 
                    v-if="this.content[1].need_pay_inflow_finish == 1"
                    id="c-m-hp-4" 
                    :name="isMobile ? $t('components.service.modal.History.49') : $t('components.service.modal.History.36')" 
                    class='h56 mr16 equal-width' 
                    type='btn-outline-red' 
                    @click='this.payInflowFinish("decline ")'
                />
                <Button 
                    v-if="this.content[1].need_pay_inflow_finish == 1"
                    id="c-m-hp-3" 
                    :name="isMobile ? $t('components.service.modal.History.48') : $t('components.service.modal.History.35')" 
                    class='h56 equal-width mr16' 
                    type='btn-outline-success' 
                    @click='this.payInflowFinish("accept")'
                />
                <Button
                    id="c-m-hp-11"
                    v-if='+this.content[1].repealing == 1'
                    :name="isMobile ? $t('components.service.modal.History.47') : $t('components.service.modal.History.20')"
                    class='equal-width h56 mr16'
                    :type='this.content[1].need_pay_inflow_finish == 1 ? "btn-outline-grey" : "btn-outline-warning"'
                    @click='this.cancelPayment'
                />
                <Button
                    id="c-m-hp-12"
                    v-if="this.isRepeatOperation"
                    :name="isMobile ? $t('components.service.modal.History.46') : $t('components.service.modal.History.21')"
                    class='h56 equal-width'
                    type='btn-warning'
                    @click='this.repeatOperation'
                />

            </div>
        </div>
        <div v-else>
            <div class="bg-white">
                <div class="fsp20 lh28 neue mb16">{{ this.$t('components.service.modal.InvoiceDetails.20') }}</div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="primary-grey neue-roman text-nowrap fsp14">URL</div>
                    <div class="d-flex align-items-center gap-1 min-w-0">
                        <a :href="this.content[1].callback_request" target="_blank" class="fsp14 ml16 text-truncate neue">{{ this.content[1].callback_request }}</a>
                        <Icon name="copy" class="c16 pointer" @click="this.copy(this.content[1].callback_request)"/>
                    </div>
                </div>
                <Warning fontSize="14" :warning="getNotification" :hideCloseBtn="true" class="m-0 my16" />
                <CallbackTable :callbacks="this.merchant_callbacks_tries" />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '@/components/service/InputSimple';
import lib from '@/includes/lib.js';
import Text from '@/components/service/Text';
import HistoryParamsLine from '@/components/service/modals/HistoryParamsLine';
import Icon from '@/components/icons/Icon';
import CustomSelectButton from '@/components/service/CustomSelectButton';
import Warning from '@/components/service/Warning';
import CallbackTable from '@/components/service/CallbackTable';

export default {
    components: {
        Button,
        InputSimple,
        Text,
        HistoryParamsLine,
        Icon,
        CustomSelectButton,
        Warning,
        CallbackTable
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            content: this.$store.state.modal.content,
            main_content: [],
            data: {
                template_name: '',
                protect_code: ''
            },
            more_opt: [],
            gen_opt: [],
            exp_post: [],
            acc_balnace: [],
            kernel_blocks: [],  
            merchant_callbacks_tries: [],
            save_t: false,
            showMoreLines: false,
            section: '0',
            showAll: false,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        sections() {
            return [
                { label: this.isMobile ? this.$t('components.service.modal.History.53') : this.$t('components.service.modal.History.45'), value: '0' },
                { label: this.$t('components.service.modal.History.8'), value: '1' },
            ];
        },
        isRepeatOperation() {
            return this.content[1]['code_cmd'] == 'pay_momental' || 
                this.content[1]['code_cmd'] == 'pay_from_gate' || 
                this.content[1]['code_cmd'] == 'transfer_keyt' ||
                (this.content[1]['code_cmd'] == 'pay_id' && this.content[1].tl_code !== '2');
        },
        getNotification() {
            if(this.content[1].callback_status == '30') {
                return { warningType: 'notification', warningText: this.content[1].callback_status_text };
            } else if(this.content[1].callback_status == '20') {
                return { warningType: 'warning', warningText: this.content[1].callback_status_text };
            } else if(this.content[1].callback_status == '40') {
                return { warningType: 'error', warningText: this.content[1].callback_status_text };
            }
        },
    },
    created() {
        console.log(this.content);
        this.setMain();
    },
    watch: {
    },
    methods: {
        updateState(state) {
            this.data[state.id] = state.value;
        },
        substrHash(str) {
            if (str && str.length > 16) {
                return str.substr(0,8) + '...' + str.substr(str.length - 8, str.length);
            } else {
                return '';
            }
        },
        setMain() {
            this.content[0].forEach(e => {
                if (e.name == 'more_options') {
                    this.more_opt = e.colvalues;
                } else if (e.name == 'general_options') {
                    this.gen_opt = e.colvalues;
                } else if (e.name == 'export_postings') {
                    this.exp_post = e.colvalues;
                } else if (e.name == 'account_balances') {
                    this.acc_balnace = e.colvalues;
                } else if(e.name == 'merchant_callbacks_tries') {
                    this.merchant_callbacks_tries = e.colvalues;
                } else if (e.name == 'kernel_blocks') {
                    this.kernel_blocks = e.colvalues;
                }
            })
            let o = [];
            //o.push({param: this.$t('components.service.modal.History.24'), value: this.content[1]['transact']});
            o.push({ id: 'code_text', param: this.$t('components.service.modal.History.25'), value: this.content[1]['code_text']});
            o.push({ id: 'date', param: this.$t('components.service.modal.History.27'), value: this.formatDate(this.content[1]['date'])});
            if(+this.content[1]['id_corr'] == this.$store.state.userData.id) {
                o.push({ id: 'pay_sum', param: this.$t('components.service.modal.History.41'), value: this.content[1]['pay_sum'] + " " + this.content[1]['pay_curr']});
                o.push({ id: 'itogo', param: this.$t('components.service.modal.History.42'), value: this.content[1]['itogo'] + " " + this.content[1]['shop_curr']});
                if (this.content[1]['accounting_pay_sum']) {
                    o.push({id: 'accounting_sum', param: this.$t('components.service.modal.History.50'), value: this.content[1]['accounting_pay_sum'] + " " + this.content[1]['accounting_pay_curr_text']});
                }
                o.push({ id: 'comiss', param: this.$t('components.service.modal.History.40'), value: this.content[1]['comiss_pay'] + " " + this.content[1]['pay_curr']});
                o.push({ id: 'comiss_shop', param: this.$t('components.service.modal.History.39'), value: this.content[1]['comiss_shop'] + " " + this.content[1]['shop_curr']});
            } else {
                o.push({ id: 'amount', param: this.$t('components.service.modal.History.28'), value: this.content[1]['itogo'] + " " + this.content[1]['shop_curr']});
                if (this.content[1]['accounting_shop_sum']) {
                    o.push({ id: 'accounting_sum', param: this.$t('components.service.modal.History.50'), value: this.content[1]['accounting_shop_sum'] + " " + this.content[1]['accounting_shop_curr_text']});
                }
                o.push({ id: 'comiss', param: this.$t('components.service.modal.History.29'), value: this.content[1]['comiss'] + " " + this.content[1]['curr']});
            }
            if (this.content[1]['code_cmd'] == 'create_echeck') {
                o.push({param: this.$t('components.service.modal.History.26'), value: this.content[1]['name_corr']});
            } else if (this.content[1]['id_corr']) {
                o.push({param: this.$t('components.service.modal.History.26'), value: this.content[1]['id_corr']});
            }
            o.push({ id: 'status', param: this.$t('components.service.modal.History.31'), value: this.content[1]['done']});
            if (
                (this.content[1]['code_cmd'] == 'pay_momental' || 
                this.content[1]['code_cmd'] == 'pay_from_gate' || 
                this.content[1]['code_cmd'] == 'pay_inflow' || 
                this.content[1]['code_cmd'] == 'merchant_purchase') 
                && this.content[1]['subj_param'].length <= 15
            ) {
                o.push({param: this.$t('components.service.modal.History.32'), value: this.content[1]["subj_param"]});
            }
            o.push({ id: 'comment', param: this.$t('components.service.modal.History.30'), value: this.content[1]['comment'].replace(/(\S{30})/g, "$1<br>")});
            this.main_content = o;
        },
        cancelPayment() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    this.axios.post('CancelPayment', {data: {'transact': this.content[1].transact}})}
                },
            });
        },
        textIsSum(id) {
            return id == 'accounting_sum' || id == 'amount' || id == 'itogo' || id == 'pay_sum' || id == 'comiss' || id == 'comiss_shop' || id == 'comiss_pay';
        },
        formatDate(date) {
            if(date.split(' ')[1]) {
                return date.split(' ')[0].split('-').reverse().join('.') + ', ' + date.split(' ')[1];
            }
            return date.split('-').reverse().join('.');
        },
        getStatus(done) {
            const text = {
                '1': this.$t('views.History.66'),
                '-2': this.$t('views.History.68'),
                '2': this.$t('views.History.68'),
                '0': this.$t('views.History.67'),
                '3': this.$t('views.History.68'),
                '-3': this.$t('views.History.68'),
                '4': this.$t('views.History.72'),
                '5': this.$t('views.History.68'),
                '-1': this.$t('views.History.68'),
            }

            return text[done] ? text[done] : text['0'];
        },
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        saveTemplate() {
            let keyt = this.$store.getters.get_keyts;
            let precision = 2;
            keyt.forEach(e => {
                if (e.keyt == this.content[1]['keyt']) {
                    precision = e.precision;
                } 
            })
            if (this.content[1]['code_cmd'] == 'pay_id') {
		        let params = {};
	            params['keyt'] = this.content[1]['keyt'];
	            params['corr_keyt'] = this.content[1]['keyt_shop'];
	            params['corr_id'] = this.content[1]['id_corr'];
	            //params['corr_name'] = this.content[1]['name_corr'];
	            params['curr'] = this.content[1]['curr'];
	            params['template_name'] = this.data.template_name;
	            params['comment'] = this.content[1]['comment'];
                params['sum'] = this.$lib.precRound(this, Number(this.content[1]['itogo']) - Number(this.content[1]['comiss']), Number(precision));
                console.log('saveTemplate params["sum"]', params['sum']);
	            // params['sum'] = this.content[1]['itogo'];
                this.axios.post('CreateTransferTemplate', {data: params})
            } else if(this.content[1]['code_cmd'] == 'transfer_keyt') {
                const params = {}
                params['keyt'] = this.content[1]['keyt_shop'];
                params['corr_id'] = this.content[1]['id_corr'];
                params['corr_keyt'] = this.content[1]['keyt'];
                params['sum'] = this.$lib.precRound(this, Number(this.content[1].shop_sum), Number(precision));
                params['template_name'] = this.data.template_name;
                this.axios.post('CreateTransferTemplate', {data: params})
            } else {
		        let params = {} ;
                params['corr_id'] = this.content[1]['id_corr'];
		        params['template_name'] = this.data.template_name;
		        params['comment'] = this.content[1]['comment'];
		        params['payform'] = this.content[1]["subj_param"];
                params['sum'] = this.$lib.precRound(this, Number(this.content[1]['itogo']) - Number(this.content[1]['comiss']), Number(precision));
		        // params['sum'] = ((+this.content[1]['itogo'].split(' ')[0]).toFixed(precision) - (+this.content[1]['comiss'].split(' ')[0]).toFixed(precision)).toFixed(precision);
		        params['keyt'] = this.content[1]['keyt'];

		        var fields = this.more_opt;
		        for (let i = 1, il = fields.length; i <= il; i++) {
			        params[i] = fields[i - 1] ? fields[i - 1].value : '';
		        }
                this.axios.post('SaveCatalogTemplate', {data: params});	        
            }

            this.save_t = !this.save_t;
        },
        repeatOperation(){
            let adv = this.content[1];
            let vals = this.content[0];
            if (adv.code_cmd === 'pay_id') {
                let params = {
                    id_corr: adv.id_corr,
                    summ: adv.itogo,
                    comment: adv.comment,
                    keyt: adv.keyt,
                };
                this.$router.push({name: 'Transfer_id', query: params})
            } else if (adv.code_cmd === 'pay_momental') {
                let params = {
                    payform: adv.subj_param,
                    summ: adv.itogo,
                    comment: adv.comment,
                    keyt: adv.keyt,
                    grp: this.more_opt[0]['field_group'],
                    fields: JSON.stringify(this.more_opt),
                    name: adv.name_corr,
                };
                this.$router.push({name: 'Pay', query: params})
            } else if (adv.code_cmd === 'merchant_purchase_pretransact' || adv.code_cmd === 'merchant_semiauto' || adv.code_cmd === 'merchant' || adv.code_cmd == 'pay_from_gate') {
                let params = {
                    payform: adv.subj_param,
                    keyt: adv.keyt,
                    fields: JSON.stringify(this.more_opt), 
                };
                this.$router.push({name: 'Payin', query: params})
            } else if (adv.code_cmd === 'transfer_keyt') {
                let params = {
                    keyt: adv.keyt_shop,
                    keyt_to: adv.keyt,
                    sum: adv.shop_sum,
                };
                this.$router.push({name: 'Transfer_self', query: params})
            }
            this.close();
        },
        payProtect() {
            let data = {
                transact_num: this.content[1]['transact'],
	            protect_code: this.data.protect_code,
            }
            this.$store.commit('MODAL', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    this.axios.post('EndPayProtect', {data: data}).then(res => {
                        this.content.update();
                    })
                }},
            });
        },
        payInflowFinish (operationType) {
            console.log(operationType)
            this.$store.commit('MODAL', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    this.axios.post('PayInflowFinish ', {data: {'transact': this.content[1].transact, 'operation': operationType}})
                    .then(res => {
                        this.content.update();
                    })}
                },
            });
        },
        getAlias(keyt) {
            let k = this.$store.getters.get_keyts;
            let a = false;
            k.forEach(e => {
                if (e.keyt == keyt) {
                    if (e.alias) {
                        a = this.substrHash(e.alias);
                    }
                }
            })
            return a ? a : keyt;
        },
    },
}
</script>

<style lang="scss" scoped>
    h4 {
        font-family: 'HelveticaNeue' !important;
    }
    .big {
        background-size: contain;
        cursor: pointer;
    }

    @media (max-width: 575px) {
        .no-pr {
            padding-right: 0 !important;
        }
    }
    .w_warp {
        word-break: break-all;
    }
    .w-unset {
        width: unset;
    }
    .link-border {
        padding-bottom: 2px;
        border-bottom: 1px solid $color-menu;
    }
    .h30 {
        height: 30px;
    }
</style>